import {
  red,
  grey,
  deepOrange,
  orange,
  indigo,
  blue,
  green,
  blueGrey,
  purple,
  deepPurple,
  brown,
  lime,
  lightBlue,
  cyan,
  pink,
} from '@material-ui/core/colors';

const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: indigo[900],
    main: indigo[500],
    light: indigo[100],
  },
  secondary: {
    contrastText: white,
    dark: blue[900],
    main: blue.A400,
    light: blue.A400,
  },
  success: {
    contrastText: white,
    dark: green[900],
    main: green[600],
    light: green[400],
  },
  info: {
    contrastText: white,
    dark: blue[900],
    main: blue[600],
    light: blue[400],
  },
  warning: {
    contrastText: white,
    dark: orange[900],
    main: orange[600],
    light: orange[400],
  },
  error: {
    contrastText: white,
    dark: red[900],
    main: red[600],
    light: red[400],
  },
  text: {
    primary: blueGrey[900],
    secondary: blueGrey[600],
    link: blue[700],
  },
  link: blue[700],
  background: {
    default: '#F4F6F8',
    paper: white,
  },
  badges: {
    red: red[300],
    blue: blue[300],
    indigo: indigo[300],
    purple: purple[300],
    deepPurple: deepPurple[300],
    lightBlue: lightBlue[300],
    lime: lime[300],
    green: green[300],
    orange: orange[300],
    deepOrange: deepOrange[300],
    brown: brown[300],
    cyan: cyan.A200,
    pink: pink[300],
  },
  icon: blueGrey[600],
  divider: grey[200],
  tableBorder: grey[300],
  avatarFallbackColor: orange.A200,
};
